import React from "react";
import { CheckCircle2Icon, LockIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { bundleFeatures, images } from "../data/content";
export function PricingOffer({
  id
}: {
  id?: string;
}) {
  return <section id={id} className="bg-peach px-4 py-14" aria-labelledby={`${id}-title`} data-id="element-104" data-mp="1vux0qcdi2na5">
      <div className="mx-auto max-w-5xl" data-id="element-105" data-mp="1qw3kwdaqqk6t">
        <h2 id={`${id}-title`} className="text-center font-heading text-2xl font-bold uppercase leading-tight md:text-3xl" data-id="element-106" data-mp="1qsxwl09xrmc5">
          Everything you need to build with confidence,
          <br data-id="element-107" data-mp="2jk7uvb0chjfb" />
          <span className="text-brand" data-id="element-108" data-mp="2jhli8wylkdq8">all in one pack</span>
        </h2>
        <p className="mx-auto mt-3 max-w-3xl text-center text-sm text-ink-muted" data-id="element-109" data-mp="2ej1x2yrtv5yx">
          Stop hunting for incomplete plans online. Everything here is organized, tested and ready for you to start today.
        </p>

        <div className="mt-10 grid items-center gap-8 rounded-xl bg-white p-6 shadow-sm md:grid-cols-2 md:p-10" data-id="element-110" data-mp="136raja3og62x">
          <img src={images.productBox} alt="Woodworking plans bundle" className="w-full rounded-lg" data-id="element-111" data-mp="y8pteuptagu3" />
          <div data-id="element-112" data-mp="1dmujvbj8vy7u">
            <h3 className="font-heading text-xl font-bold uppercase text-brand" data-id="element-113" data-mp="1hq0jw1frkt5v">The ultimate DIY plans collection</h3>
            <ul className="mt-5 space-y-2.5" data-id="element-114" data-mp="13ramekp18rgz">
              {bundleFeatures.map(f => <li key={f} className="flex items-start gap-2 text-sm" data-id="element-115" data-mp="18plwmwj8p3zq">
                  <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-116" data-mp="18roxkblxkhj8" />
                  <span data-id="element-117" data-mp="tylf820ilzrg">{f}</span>
                </li>)}
            </ul>
            <div className="mt-6 flex items-baseline gap-3" data-id="element-118" data-mp="ys7tfymbubpd">
              <span className="font-heading text-3xl font-bold text-brand" data-id="element-119" data-mp="l0jivzrq7vai">$37.00</span>
              <span className="text-lg text-ink-muted line-through" data-id="element-120" data-mp="pz4ajaswx6nc">$97.00</span>
              <span className="rounded bg-brand/10 px-2 py-0.5 text-xs font-bold text-brand" data-id="element-121" data-mp="pwqf30ublsf9">-60%</span>
            </div>
            <div className="mt-5 flex justify-start" data-id="element-122" data-mp="g0nfa1mxy5vh">
              <CtaButton label="Get the collection" data-id="element-123" data-mp="g0ewxu81u8cw" />
            </div>
            <div className="mt-4 flex flex-wrap items-center gap-2 text-xs text-ink-muted" data-id="element-124" data-mp="3t2r7qv5dwzbu">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-125" data-mp="3oaplqhiezu8m" />
              <span data-id="element-126" data-mp="3jbw9stis0bak">Secure checkout</span>
              {["VISA", "Mastercard", "PayPal", "AMEX"].map(p => <span key={p} className="rounded border border-neutral-200 px-2 py-0.5 font-bold text-ink" data-id="element-127" data-mp="3j9jwwurvkr4d">
                  {p}
                </span>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}